import { CustomAutocompleteShadcn } from "../../../components/custom-autocomplete-shadcn.component";
import { X } from "lucide-react";

const SHOW_ALL = "ALL";

export const AccountingRecipientSelector: React.FC<{
	onRecipientChange: (recipientId: string) => void;
	selectedRecipientId: string;
	recipientList: Record<
		string,
		{
			type: "client" | "guarantor";
			name: string;
		}
	>;
}> = ({ selectedRecipientId, onRecipientChange, recipientList }) => {
	if (!recipientList || Object.keys(recipientList).length === 0) {
		return null;
	}

	const options = [
		{ value: SHOW_ALL, label: "Alle" },
		...Object.entries(recipientList)
			.filter(([_, recipient]) => recipient && recipient.name)
			.sort((a, b) => a[1].name.localeCompare(b[1].name))
			.map(([id, { name }]) => ({
				value: id,
				label: name,
			})),
	];

	return (
		<div className="flex items-center gap-2">
			<span className="text-sm text-gray-500 whitespace-nowrap">Kunde/Garant:</span>
			<CustomAutocompleteShadcn
				options={options}
				inputLabel=""
				value={selectedRecipientId || SHOW_ALL}
				onChange={(value) => onRecipientChange(value as string)}
			/>
			{selectedRecipientId !== SHOW_ALL && (
				<button
					type="button"
					onClick={() => onRecipientChange(SHOW_ALL)}
					className="text-gray-400 hover:text-gray-600"
					aria-label="Adressaten entfernen"
				>
					<X size={16} />
				</button>
			)}
		</div>
	);
};
